<template>
  <div id="new-user-video-box">
    <div class="user-video-box-inner">
      <div class="video-bg"></div>
      <video :src="videoUrl" controls @error="loadError"></video>
      <div class="error-cover" v-show="loadVideoError">
        <div class="error-content">
          <img src="../../../../assets/imgs/acadmy/video_wrong.png">
          <div class="error-msg">视频出错了</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'new-user-video-box',
  props: {
    videoUrl: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      loadVideoError: false,
    };
  },
  methods: {
    loadError() {
      this.loadVideoError = true;
    },
  },
};
</script>

<style lang="less">
#new-user-video-box {
  background-color: white;
  padding: 30px 70px;
  .user-video-box-inner {
    background-color: #f3f4f6;
    position: relative;
    display: flex;
    .video-bg {
      width: 100%;
      height: 0;
      padding-bottom: 56.25%;
    }
    video {
      position: absolute;
      z-index: 1;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      width: 100%;
    }
    .error-cover {
      background-color: #f3f4f6;
      position: absolute;
      z-index: 2;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .error-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          margin-bottom: 20px;
        }
        .error-msg {
          font-size: 16px;
          color: #666;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/guide/newUser/components/new-user-video-box.vue